import React from 'react'
import validator from 'validator'
import { FormattedMessage } from 'react-intl'

//phone reg
export const __reg_phone_normal__ = /^\d{5,20}$/
export const __reg_phone_br__ = /^\d{10,11}$/
export const __reg_phone_ae_ = /^(50|52|54|55|56|58|2|3|4|6|7|9){1,2}\d{7}$/
export const __reg_phone_sa_ = /^(50|53|55|51|58|59|54|56|57|11|12|13|14|16|17|811){1,3}\d{7}$/


//zip reg
export const __reg_zip_us__ = /^(([0-9]{5})|([0-9]{5}-[0-9]{4}))$/ // 美国
export const __reg_zip_uk__ = /^([a-z]|[A-Z]){1,2}\w{1,2}\s{0,1}[0-9]{1}([a-z]|[A-Z]){2}$/ //英国
export const __reg_zip_br__ = /^[0-9]{5}-[0-9]{3}$/ // 巴西
export const __reg_zip_mx__ = /^[0-9]{5}$/ // 墨西哥
export const __reg_zip_de__ = /^((0[1-9])|([1-9][0-9]))[0-9]{3}$/ //德意志
export const __reg_zip_fr__ = /^[0-9]{5}$/ // 法兰西
export const __reg_zip_es__ = /^(0[1-9]|[1-4][0-9]|5[0-2])[0-9]{3}$/ //西班牙
export const __reg_zip_it__ = /^[0-9]{5}$/ // 意大利
export const __reg_zip_at__ = /^[1-9][0-9]{3}$/ // 奥地利
export const __reg_zip_be__ = /^[1-9][0-9]{3}$/ // 比利时
export const __reg_zip_au__ = /^[0-9]{4}$/ // 澳大利亚
export const __reg_zip_bg__ = /^[0-9]{4}$/ // 保加利亚
export const __reg_zip_ca__ = /^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z][\s-]?[0-9][ABCEGHJ-NPRSTV-Z][0-9]$/i //加拿大
export const __reg_zip_ch__ = /^[1-9][0-9]{3}$/ // 瑞士
export const __reg_zip_cy__ = /^[0-9]{4}$/ // 塞浦路斯
export const __reg_zip_cz__ = /^[0-9]{3}\s?[0-9]{2}$/ // 捷克
export const __reg_zip_ee__ = /^[0-9]{5}$/ // 爱沙尼亚
export const __reg_zip_fi__ = /^[0-9]{5}$/ // 芬兰
export const __reg_zip_gr__ = /^[0-9]{3}\s?[0-9]{2}$/ //希腊
export const __reg_zip_hr__ = /^[0-9]{5}$/ // 克罗地亚
export const __reg_zip_ie__ = /^([AC-FHKNPRTV-Y][0-9]{2}|D6W)\s?[0-9AC-FHKNPRTV-Y]{4}$/i // 爱尔兰
export const __reg_zip_lt__ = /^([Ll][Tt][-\s]?)?[0-9]{5}$/ // 立陶宛
export const __reg_zip_lu__ = /^[0-9]{4}$/ // 卢森堡
export const __reg_zip_lv__ = /^[Ll][Vv][-\s]?[0-9]{4}$/ // 拉脱维亚
export const __reg_zip_nl__ = /^[1-9][0-9]{3}\s?((?!SS$|SD$|SA$)[A-Z]{2})$/i // 荷兰
export const __reg_zip_no__ = /^[0-9]{4}$/ // 挪威
export const __reg_zip_nz__ = /^[0-9]{4}$/ // 新西兰
export const __reg_zip_pl__ = /^([0-9]{2}[-\s]?[0-9]{3})$/ // 波兰
export const __reg_zip_pt__ = /^([0-9]{4}[-\s]?[0-9]{3})$/ // 葡萄牙
export const __reg_zip_ro__ = /^[0-9]{6}$/ // 罗马尼亚
export const __reg_zip_se__ = /^[0-9]{3}\s?[0-9]{2}$/ // 瑞典
export const __reg_zip_dk__ = /(^([1-9][0-9]{3})$)|(^(0[8-9][0-9]{2})$)/ // 丹麦

export const countryRegObj = {
    "US": __reg_zip_us__,
    "GB": __reg_zip_uk__,
    "UK": __reg_zip_uk__,
    "BR": __reg_zip_br__,
    "MX": __reg_zip_mx__,
    "DE": __reg_zip_de__,
    "FR": __reg_zip_fr__,
    "ES": __reg_zip_es__,
    "IT": __reg_zip_it__,
    "AT": __reg_zip_at__,
    "CH": __reg_zip_ch__,
    "BE": __reg_zip_be__,
    "AU": __reg_zip_au__,
    "BG": __reg_zip_bg__,
    "CA": __reg_zip_ca__,
    "CH": __reg_zip_ch__,
    "CY": __reg_zip_cy__,
    "CZ": __reg_zip_cz__,
    "EE": __reg_zip_ee__,
    "FI": __reg_zip_fi__,
    "GR": __reg_zip_gr__,
    "HR": __reg_zip_hr__,
    "IE": __reg_zip_ie__,
    "LT": __reg_zip_lt__,
    "LU": __reg_zip_lu__,
    "LV": __reg_zip_lv__,
    "NL": __reg_zip_nl__,
    "NO": __reg_zip_no__,
    "NZ": __reg_zip_nz__,
    "PL": __reg_zip_pl__,
    "PT": __reg_zip_pt__,
    "RO": __reg_zip_ro__,
    "SE": __reg_zip_se__,
    "DK": __reg_zip_dk__,
}

export const countryErrorTipObj = {
    "US": <FormattedMessage id="wrong_zip_code_us" />,
    "GB": <FormattedMessage id="wrong_zip_code_uk" />,
    "UK": <FormattedMessage id="wrong_zip_code_uk" />,
    "BR": <FormattedMessage id="wrong_zip_code_br" />,
    "MX": <FormattedMessage id="wrong_zip_code_mx" />,
    "DE": <FormattedMessage id="wrong_zip_code_de" />,
    "FR": <FormattedMessage id="wrong_zip_code_fr" />,
    "ES": <FormattedMessage id="wrong_zip_code_es" />,
    "IT": <FormattedMessage id="wrong_zip_code_it" />,
    "AT": <FormattedMessage id="wrong_zip_code_at" />,
    "BE": <FormattedMessage id="wrong_zip_code_be" />,
    "AU": <FormattedMessage id="wrong_zip_code_au" />,
    "BG": <FormattedMessage id="wrong_zip_code_bg" />,
    "CA": <FormattedMessage id="wrong_zip_code_ca" />,
    "CH": <FormattedMessage id="wrong_zip_code_ch" />,
    "CY": <FormattedMessage id="wrong_zip_code_cy" />,
    "EE": <FormattedMessage id="wrong_zip_code_ee" />,
    "LU": <FormattedMessage id="wrong_zip_code_lu" />,
    "LV": <FormattedMessage id="wrong_zip_code_lv" />,
    "NL": <FormattedMessage id="wrong_zip_code_nl" />,
    "NZ": <FormattedMessage id="wrong_zip_code_nz" />,
    "RO": <FormattedMessage id="wrong_zip_code_ro" />,
    "HR": <FormattedMessage id="wrong_zip_code_hr" />,
    "PT": <FormattedMessage id="wrong_zip_code_pt" />,
    "SE": <FormattedMessage id="wrong_zip_code_se" />,
    "NO": <FormattedMessage id="wrong_zip_code_no" />,
    "FI": <FormattedMessage id="wrong_zip_code_fi" />,
    "DK": <FormattedMessage id="wrong_zip_code_dk" />,
    "CZ": <FormattedMessage id="wrong_zip_code_cz" />,
    "GR": <FormattedMessage id="wrong_zip_code_gr" />,
    "IE": <FormattedMessage id="wrong_zip_code_ie" />,
    "LT": <FormattedMessage id="wrong_zip_code_lt" />,
    "PL": <FormattedMessage id="wrong_zip_code_pl" />,
}

export const cpfcheck = (value) => {
    var result = true

    value = value.replace('-', '')
    value = value.replace(/\./g, '')

    // this is mostly not needed
    var invalidos = ['11111111111', '22222222222', '33333333333',
        '44444444444', '55555555555', '66666666666',
        '77777777777', '88888888888', '99999999999',
        '00000000000']

    for (let i = 0; i < invalidos.length; i++) {
        if (invalidos[i] == value) {
            result = false
        }
    }

    if (value.length > 11) {
        result = false
    }

    // validando primeiro digito
    let add = 0
    for (let i = 0; i < 9; i++) {
        add += parseInt(value.charAt(i), 10) * (10 - i)
    }
    let rev = 11 - (add % 11)
    if (rev == 10 || rev == 11) {
        rev = 0
    }
    if (rev != parseInt(value.charAt(9), 10)) {
        result = false
    }

    // validando segundo digito
    add = 0
    for (let i = 0; i < 10; i++) {
        add += parseInt(value.charAt(i), 10) * (11 - i)
    }
    rev = 11 - (add % 11)
    if (rev == 10 || rev == 11) {
        rev = 0
    }
    if (rev != parseInt(value.charAt(10), 10)) {
        result = false
    }

    return result
}


export const testPhone = (phone, country) => {
    let reg
    switch (country) {
        case 'BR':
            reg = __reg_phone_br__
            break
        case 'AE':
            reg = __reg_phone_ae_
            break
        case 'SA':
            reg = __reg_phone_sa_
            break
        default:
            reg = __reg_phone_normal__
            break
    }
    if(phone && reg.test(phone)){
        // 检查号码是否为相同数字
        let str = phone.toString()
        let strList = str.split('')
        let simpleList = new Set(strList)
        let checkList = [...(simpleList || [])]
        if(checkList.length > 1){
            return true
        }
    }
    return false
}

export const testZip = (zip, country) => {
    if(!zip) return false
    return !countryRegObj[country] || countryRegObj[country].test(zip)
}


// 巴西门牌号
export const testUnit = (unit, country) => {
    if (country === 'BR') {
        if (!unit) return false
        return validator.isNumeric(unit) && unit.length >= 1 && unit.length <= 20
    }
    return true
}

export const testCpf = (cpf, country) => {
    if (country === 'BR') {
        if (!cpf) return false
        return cpfcheck(cpf)
    }
    return true
}


export default (intl, checkEmail) => {

    return (values, props) => {

        const errors = {}

        if (checkEmail) {
            //email
            if (!values.email) {
                errors.email = intl.formatMessage({ id: 'required', defaultMessage: 'Required' })
            } else if (!validator.isEmail(values.email)) {
                errors.email = intl.formatMessage({ id: 'invalid_email_address', defaultMessage: '{email} is not a valid email' }, { email: values.email })
            }
        }

        if (values.country === 'DE') {
            if (values.streetAddress1) {
                if (!(/\d/.test(values.streetAddress1))) {
                    errors.streetAddress1 = 'Füllen Sie bitte Ihre Hausnummer aus.'
                }
            }
        }


        //first name
        if (!values.firstName) {
            errors.firstName = intl.formatMessage({ id: 'required', defaultMessage: 'Required' })
        } else if (validator.isNumeric(values.firstName)) {
            errors.firstName = intl.formatMessage({ id: 'first_name_reg_default', defaultMessage: 'First Name should contain non-pure numeric 1-40 characters' })
        }

        //last name
        if (!values.lastName) {
            errors.lastName = intl.formatMessage({ id: 'required', defaultMessage: 'Required' })
        } else if (validator.isNumeric(values.lastName)) {
            errors.lastName = intl.formatMessage({ id: 'last_name_reg_default', defaultMessage: 'Last Name should contain non-pure numeric 1-40 characters' })
        }

        if (!values.phoneNumber && values.phoneNumber != 0) {
            errors.phoneNumber = intl.formatMessage({ id: 'required', defaultMessage: 'Required' })
        } else if (!testPhone(values.phoneNumber, values.country)) {
            switch (values.country) {
                case 'BR':
                    errors.phoneNumber = intl.formatMessage({ id: 'phone_reg_10_11', defaultMessage: 'Enter at least 10-11 numbers.' })
                    break
                case 'AE':
                    errors.phoneNumber = intl.formatMessage({ id: 'phone_reg_ae', defaultMessage: 'Phone numbers should start with 50/52/54/55/56/58/2/3/4/6/7/9, followed by any 7 digits.' })
                    break
                case 'SA':
                    errors.phoneNumber = intl.formatMessage({ id: 'phone_reg_sa', defaultMessage: 'Phone numbers should start with 50/53/55/51/58/59/54/56/57/11/12/13/14/16/17/811, followed by any 7 digits.' })
                    break
                default:
                    errors.phoneNumber = intl.formatMessage({ id: 'phone_reg_default', defaultMessage: 'Incorrect phone number format (numbers only, no formatting)' })
                    break
            }
        }

        if (!values.zipCode) {
            errors.zipCode = intl.formatMessage({ id: 'required', defaultMessage: 'Required' })
        } else if (!testZip(values.zipCode, values.country)) {
            errors.zipCode = countryErrorTipObj[values.country || 'none'] || ''
        }

        if (!values.streetAddress1) {
            errors.streetAddress1 = intl.formatMessage({ id: 'required', defaultMessage: 'Required' })
        } else if (validator.isNumeric(values.streetAddress1)) {
            errors.streetAddress1 = intl.formatMessage({ id: 'invalid_address', defaultMessage: 'Incorrect address format' })
        }

        if (!values.city) {
            errors.city = intl.formatMessage({ id: 'required', defaultMessage: 'Required' })
        }

        if (!values.state) {
            errors.state = intl.formatMessage({ id: 'required', defaultMessage: 'Required' })
        }

        if (!testUnit(values.unit, values.country)) {

            if (!values.unit) {
                errors.unit = intl.formatMessage({ id: 'required', defaultMessage: 'Required' })
            } else {
                switch (values.country) {
                    case 'BR':
                        errors.unit = 'O número deve ter entre 1 e 20 caracteres numéricos puros.'
                        break
                    default:
                        break
                }
            }

        }

        if (!testCpf(values.cpf, values.country)) {

            if (!values.cpf) {
                errors.cpf = intl.formatMessage({ id: 'required', defaultMessage: 'Required' })
            } else {
                errors.cpf = intl.formatMessage({ id: 'not_vaild_cpf', defaultMessage: '{value} não é um CPF válido' }, { value: values.cpf })
            }
        }

        return errors
    }
}